import HighlyRatedFor from 'components/ProductPage/RatingsAndReviews/HighlyRatedFor/HighlyRatedFor';
import { withHighlyRatedForProps } from 'viewModel/productPage/ratingsAndReviews/highlyRatedFor/withHighlyRatedForProps';

export default withHighlyRatedForProps(HighlyRatedFor);
